export default __webpack_public_path__ + "static/media/sidebar-annotated.5e48a20d.png";